/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * UserGuidanceBanner
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Button, Space, Text, Conditional } from '@cashfree-intl/coherent';
import {
  ANDROID,
  IOS,
  MERCHANT_DASHBOARD_MOBILE_APP_URL,
} from '../../utils/constants';
import CustomIcon from '../CustomIcons';

function UserGuidanceBanner({ type, isShellV2 = false }) {
  const isAndroid = type === ANDROID;
  const isIOS = type === IOS;
  const location = useLocation();
  const isPGPage = location.pathname.split('/')[2] === 'pg';

  return (
    <Conditional if={isAndroid || isIOS}>
      <div
        className={`align-center banner ${isAndroid &&
          'android-banner'} ${isIOS && 'iOS-banner'} ${!isShellV2 &&
          isPGPage &&
          'old-shell-pg-banner'}`}
      >
        <div className="banner-text">
          Switch to the app or use the desktop version for a seamless
          experience.
        </div>
        <Space direction="column">
          <Button
            className="banner-btn"
            onClick={() =>
              window.open(MERCHANT_DASHBOARD_MOBILE_APP_URL, '_blank')
            }
          >
            <Text variant="b12" color="white" strong>
              Get App
            </Text>
          </Button>
          <Conditional if={isAndroid}>
            <div className="banner-gplay-icon">
              <CustomIcon componentName="GOOGLE_PLAY" />
            </div>
          </Conditional>
        </Space>
      </div>
    </Conditional>
  );
}

UserGuidanceBanner.propTypes = {
  type: PropTypes.string,
  isShellV2: PropTypes.bool,
};

export default memo(UserGuidanceBanner);
